import { IProjectTemplateRateTable } from '../../interfaces/iproject-template-rate-table';
import { ItemRateTableName } from '../item-rate-table-name';
import { ProjectTemplate } from '../project-template';

export class ProjectTemplateRateTableBase {
  ProjectTemplateRateTableId: number;
  ProjectTemplateId: number | null;
  ItemRateTableNameId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ItemRateTableName?: ItemRateTableName;
  ProjectTemplate?: ProjectTemplate;

  constructor(item?: IProjectTemplateRateTable) {
    if (item) {
      this.ProjectTemplateRateTableId = item.ProjectTemplateRateTableId;
      this.ProjectTemplateId = item.ProjectTemplateId;
      this.ItemRateTableNameId = item.ItemRateTableNameId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ItemRateTableName = new ItemRateTableName(item.ItemRateTableName);
      this.ProjectTemplate = new ProjectTemplate(item.ProjectTemplate);
    }
  }
}